import { useQuery } from 'react-query';
import ProfileApi from '../ProfileApi';
import IDroneAvailability from '../IDroneAvailability';

export const droneAvailabilityQueryKey = 'me-drone-availability';

export function useDroneAvailabilityQuery(enabled: boolean) {
    return useQuery<IDroneAvailability>(
        droneAvailabilityQueryKey,
        () => ProfileApi.loadDroneAvailability(),
        {
            enabled,
            refetchOnWindowFocus: false
        }
    );
}
